import * as React from 'react'

import { DottedBackgroundCard } from 'components/dotted-background-card/DottedBackgroundCard'
import { Text, TextName } from 'sdk/text/Text'

import type { AboutVisionCmsContent } from 'core/services/cms/interfaces'

import classes from './style.module.scss'

interface VisionSectionProps {
  content: AboutVisionCmsContent
}

export const VisionSection: React.FC<VisionSectionProps> = ({ content }) => {
  return (
    <DottedBackgroundCard className={classes.container}>
      <Text type={TextName.H2}>{content.title}</Text>
      <Text type={TextName.Text}>
        {content.body}
      </Text>
    </DottedBackgroundCard>
  )
}
